"use strict";

exports["default"] = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

exports.__esModule = true;


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/helpers/object-without-properties.js
 ** module id = 583
 ** module chunks = 0
 **/